module.exports = __webpack_public_path__ + "img/icon_chatbot_send.8f7c57c1.svg";